import moment from "moment";

export default function parseTime(str) {
  const m24 = moment(str, "HH:mm", true);
  const m12 = moment(str, "h:mm A", true);
  const m = m24.isValid() ? m24 : m12.isValid() ? m12 : moment(null);
  return { hour: m.get("hour"), minute: m.get("minute") };
}
